import { AxiosError } from "axios";
import { GraphQLErrorExtensions } from "graphql/index";
import { ClientError } from "graphql-request";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";

export const getStatusCode = (error: any): number | undefined | null => {
  if (isNil(error) || !isObject(error) || !("response" in error)) {
    return null;
  }

  if (error instanceof ClientError) {
    return (
      error.response.errors?.[0].extensions as GraphQLErrorExtensions as {
        response: { status: number };
      }
    ).response?.status;
  }

  if (error instanceof AxiosError) {
    return error.response?.status;
  }

  return null;
};
